import React, { useEffect } from 'react';

import PageHttp from '~/commons/components/PageHttp.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import Header from '../../layout/Header.jsx';
import ListTfyStocks from '../../lists/tfy/ListStocks.jsx';

const PageTfyStocks = () => {
  const [res, req] = useHttpStatus();
  useEffect(() => {
    req({ url: '/api/core/users/self/showrooms' });
  }, []);

  return (
    <PageHttp res={res}>
      {(doc) => (
        <div>
          <Header>TFY Stocks</Header>
          <ListTfyStocks showrooms={doc} />
        </div>
      )}
    </PageHttp>
  );
};

export default PageTfyStocks;
